import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { transformation } from '../data/content';
export function Transformation() {
  return <section className="bg-ivory text-ink" data-id="element-225" data-mp="ikszq0c37ktm">
      <div className="mx-auto max-w-3xl px-5 py-12 sm:px-6 lg:py-20" data-id="element-226" data-mp="mmea9f15fn0n">
        <h2 className="text-center font-display text-[1.65rem] font-semibold uppercase leading-[1.1] tracking-tight sm:text-5xl" data-id="element-227" data-mp="moh7aj0pygev">
          <span className="block" data-id="element-228" data-mp="wktyna8ski6g">{transformation.titleLine1}</span>
          <span className="block" data-id="element-229" data-mp="wihjt5ybynxm">{transformation.titleLine2}</span>
        </h2>

        <ul className="mx-auto mt-8 max-w-xl space-y-2" data-id="element-230" data-mp="11hkfhzsf7hsx">
          {transformation.outcomes.map(item => <li key={item} className="flex items-start gap-3 rounded-xl bg-ivory-card px-4 py-3 ring-1 ring-stone" data-id="element-231" data-mp="16c84dzrc6e81">
              <span aria-hidden="true" className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-sage-deep" data-id="element-232" data-mp="1fatldqh5tl6p">
                <ArrowRightIcon className="h-3.5 w-3.5 text-ivory" strokeWidth={2.5} data-id="element-233" data-mp="1kay29hlzchxg" />
              </span>
              <span className="font-sans text-[0.98rem] leading-snug text-ink/90" data-id="element-234" data-mp="1c7382vgusml6">{item}</span>
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl text-center font-display text-[1.9rem] font-semibold leading-[1.08] tracking-tight text-terra-deep sm:text-5xl" data-id="element-235" data-mp="1791nu77oyh84">
          <span className="block" data-id="element-236" data-mp="y7ai52d5iae9">{transformation.closeLine1}</span>
          <span className="block" data-id="element-237" data-mp="1uw9r6jlk7g7i">{transformation.closeLine2}</span>
        </p>
      </div>
    </section>;
}